module.exports = "./img/ccdc7bc709ae86db4455965e13733c97.jpg";